import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-37840038"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "main"
};
var _hoisted_2 = {
  class: "gridLayout"
};
var _hoisted_3 = {
  class: "cardModel"
};
var _hoisted_4 = {
  class: "card-title"
};
var _hoisted_5 = {
  class: "cardDescription"
};
var _hoisted_6 = {
  class: "block-field"
};
var _hoisted_7 = {
  class: "block-field__url"
};
var _hoisted_8 = {
  class: "idp-field-label"
};
var _hoisted_9 = {
  class: "idp-field-value"
};
var _hoisted_10 = {
  class: "block-field__entity-id"
};
var _hoisted_11 = {
  class: "idp-field-label"
};
var _hoisted_12 = {
  class: "idp-field-value"
};
var _hoisted_13 = {
  class: "cardModel saml-conf-card"
};
var _hoisted_14 = {
  class: "card-title"
};
var _hoisted_15 = {
  key: 0,
  class: "section upload-ok"
};
var _hoisted_16 = {
  class: "content has-text-centered"
};
var _hoisted_17 = {
  key: 1,
  class: "section"
};
var _hoisted_18 = {
  class: "content has-text-centered"
};
var _hoisted_19 = {
  key: 0,
  class: "idp-metadata-download-block"
};
var _hoisted_20 = {
  class: "card-title"
};
var _hoisted_21 = {
  class: "cardDescription"
};
var _hoisted_22 = {
  key: 0,
  class: "config-status-desc"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});
var _hoisted_24 = {
  key: 1,
  class: "config-status-desc"
};
var _hoisted_25 = {
  class: "card-title"
};
var _hoisted_26 = {
  class: "cardDescription tableContainer"
};
var _hoisted_27 = {
  class: "card-title"
};
var _hoisted_28 = {
  class: "cardDescription"
};
var _hoisted_29 = {
  key: 0,
  class: "config-status-desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_MainTitle = _resolveComponent("MainTitle");
  var _component_Banner = _resolveComponent("Banner");
  var _component_w_icon = _resolveComponent("w-icon");
  var _component_w_standard_button = _resolveComponent("w-standard-button");
  var _component_Card = _resolveComponent("Card");
  var _component_GridItem = _resolveComponent("GridItem");
  var _component_el_upload = _resolveComponent("el-upload");
  var _component_AuthItemsAttributeTable = _resolveComponent("AuthItemsAttributeTable");
  var _component_AuthItemsAttributeMappingDialog = _resolveComponent("AuthItemsAttributeMappingDialog");
  var _component_CenterTop = _resolveComponent("CenterTop");
  var _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createBlock(_component_CenterTop, null, {
    default: _withCtx(function () {
      return [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_MainTitle, {
        "breadcrumb-items": _ctx.breadcrumbItems
      }, {
        title: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.name) + " - " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.breadcrumb').toString()), 1)];
        }),
        _: 1
      }, 8, ["breadcrumb-items"]), !!_ctx.errorMsg ? (_openBlock(), _createBlock(_component_Banner, {
        key: 0,
        type: "error"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.errorMsg), 1)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_GridItem, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_Card, {
            class: "saml-conf-card"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_w_icon, {
                icon: "download-outline",
                class: "card-title__icon"
              }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.sp_block.title').toString()), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.sp_block.subtitle').toString()), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.sp_block.url').toString()) + ": ", 1), _createElementVNode("span", _hoisted_9, [_createTextVNode(_toDisplayString(_ctx.urlASC) + " ", 1), _createVNode(_component_w_icon, {
                icon: "content-copy",
                class: "copy-icon",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.copyOnClipboard(_ctx.urlASC);
                })
              })])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.sp_block.entity_id').toString()) + ": ", 1), _createElementVNode("span", _hoisted_12, [_createTextVNode(_toDisplayString(_ctx.spEntityid) + " ", 1), _createVNode(_component_w_icon, {
                icon: "content-copy",
                class: "copy-icon",
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.copyOnClipboard(_ctx.spEntityid);
                })
              })])])])]), _createVNode(_component_w_standard_button, {
                class: "card-action-button",
                type: "primary",
                minWidth: "100%",
                onClick: _ctx.downloadSPMetadata
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_w_icon, {
                    icon: "download-outline"
                  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.sp_block.download').toString()), 1)];
                }),
                _: 1
              }, 8, ["onClick"])])];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_GridItem, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_Card, {
            class: "saml-conf-card"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_w_icon, {
                icon: "upload-outline",
                class: "card-title__icon"
              }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.title').toString()), 1)]), _createElementVNode("div", {
                class: _normalizeClass("cardDescription ".concat(_ctx.isIDPUpload ? 'idp-uploaded-card-desc' : ''))
              }, [_createVNode(_component_el_upload, {
                action: "#",
                "auto-upload": false,
                "show-file-list": false,
                accept: ".xml",
                drag: "",
                "on-change": _ctx.onFileSelected
              }, {
                default: _withCtx(function () {
                  return [_ctx.isIDPUpload ? (_openBlock(), _createElementBlock("section", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_w_icon, {
                    icon: "check",
                    size: "30px",
                    class: "uploaded-ok-icon is-success"
                  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.uploaded_desc').toString()), 1)])])) : (_openBlock(), _createElementBlock("section", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_w_icon, {
                    icon: "upload-outline"
                  }), _createElementVNode("p", null, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.upload_desc').toString()), 1)])]))];
                }),
                _: 1
              }, 8, ["on-change"])], 2), _ctx.isIDPUpload ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_w_standard_button, {
                class: "card-action-button download-idp-btn",
                type: "default",
                minWidth: "100%",
                onClick: _ctx.downloadIDPMetadata
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_w_icon, {
                    icon: "download-outline"
                  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.download').toString()), 1)];
                }),
                _: 1
              }, 8, ["onClick"])])) : _createCommentVNode("", true), _createVNode(_component_el_upload, {
                action: "#",
                "auto-upload": false,
                "show-file-list": false,
                accept: ".xml",
                "on-change": _ctx.onFileSelected
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_w_standard_button, {
                    class: "card-action-button",
                    minWidth: "100%"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_w_icon, {
                        icon: "upload-outline"
                      }), _createTextVNode(" " + _toDisplayString(_ctx.isIDPUpload ? _ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.upload_new').toString() : _ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.upload').toString()), 1)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["on-change"])])];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_GridItem, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_Card, {
            class: "saml-conf-card"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                class: _normalizeClass("cardModel config-validate-card  ".concat(!_ctx.isIDPUpload ? 'disabled' : ''))
              }, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_w_icon, {
                icon: "check-circle-outline",
                class: "card-title__icon"
              }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.title').toString()), 1)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.subtitle').toString()), 1), _ctx.isIDPUpload ? (_openBlock(), _createElementBlock("p", _hoisted_22, [_createVNode(_component_w_icon, {
                icon: "check",
                class: "status-icon is-success"
              }), _hoisted_23, _createElementVNode("span", null, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.conf_validated_desc').toString()), 1)])) : _createCommentVNode("", true), !_ctx.isIDPUpload ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.prerequisite_desc').toString()), 1)) : _createCommentVNode("", true)]), _createVNode(_component_w_standard_button, {
                class: "card-action-button",
                type: "primary",
                minWidth: "100%",
                disabled: !_ctx.isIDPUpload,
                onClick: _ctx.createAuthRequest
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_w_icon, {
                    icon: "cached"
                  }), _createTextVNode(" " + _toDisplayString(_ctx.isAuthenticationValid ? _ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.update_attr_btn').toString() : _ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.proceed_to_test_btn').toString()), 1)];
                }),
                _: 1
              }, 8, ["disabled", "onClick"])], 2)];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_GridItem, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_Card, {
            class: "saml-conf-card"
          }, {
            default: _withCtx(function () {
              var _ctx$authItem$authIte;
              return [_createElementVNode("div", {
                class: _normalizeClass("cardModel ".concat(!_ctx.isAuthenticationValid ? 'disabled' : ''))
              }, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_w_icon, {
                icon: "sitemap",
                class: "card-title__icon"
              }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.map_attribute_block.title').toString()), 1)]), _createElementVNode("div", _hoisted_26, [(_ctx$authItem$authIte = _ctx.authItem.authItemAttributes) !== null && _ctx$authItem$authIte !== void 0 && _ctx$authItem$authIte.length ? (_openBlock(), _createBlock(_component_AuthItemsAttributeTable, {
                key: 0,
                authItem: _ctx.authItem
              }, null, 8, ["authItem"])) : _createCommentVNode("", true)]), _createVNode(_component_w_standard_button, {
                class: "card-action-button",
                type: "primary",
                minWidth: "100%",
                disabled: !_ctx.isAuthenticationValid,
                onClick: _cache[2] || (_cache[2] = function ($event) {
                  return _ctx.isMapAttributeModalActive = true;
                })
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_w_icon, {
                    icon: "sitemap"
                  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.map_attribute_block.submit_btn').toString()), 1)];
                }),
                _: 1
              }, 8, ["disabled"])], 2)];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_GridItem, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_Card, {
            class: "saml-conf-card"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                class: _normalizeClass("cardModel link-platform-card ".concat(!_ctx.isAuthenticationValid || !_ctx.isCreateAuthLink ? 'disabled' : ''))
              }, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_w_icon, {
                icon: "link-lock",
                class: "card-title__icon"
              }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.platform_link_block.title').toString()), 1)]), _createElementVNode("div", _hoisted_28, [_ctx.isAuthenticationValid ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_w_icon, {
                icon: "check",
                class: "status-icon is-success"
              }), _createElementVNode("p", null, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.platform_link_block.platform_linked_desc').toString()), 1)])) : _createCommentVNode("", true)]), _createVNode(_component_w_standard_button, {
                class: "card-action-button",
                type: "primary",
                minWidth: "100%",
                disabled: !_ctx.isAuthenticationValid || !_ctx.isCreateAuthLink,
                onClick: _cache[3] || (_cache[3] = function ($event) {
                  return _ctx.goToAuthLinkCreation();
                })
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_w_icon, {
                    icon: "link-lock"
                  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.platform_link_block.submit_btn').toString()), 1)];
                }),
                _: 1
              }, 8, ["disabled"])], 2)];
            }),
            _: 1
          })];
        }),
        _: 1
      })]), _ctx.authItem ? (_openBlock(), _createBlock(_component_AuthItemsAttributeMappingDialog, {
        key: 1,
        authItem: _ctx.authItem,
        isMapAttributeModalActive: _ctx.isMapAttributeModalActive,
        onDialogClose: _cache[4] || (_cache[4] = function ($event) {
          return _ctx.isMapAttributeModalActive = false;
        })
      }, null, 8, ["authItem", "isMapAttributeModalActive"])) : _createCommentVNode("", true)])), [[_directive_loading, _ctx.loading]])];
    }),
    _: 1
  });
}